export const MARGIN_KEY = "MARGIN";

export const MARGIN_CACHE_KEYS = {
  LIST: [MARGIN_KEY, "LIST"] as const,
  DETAIL: (id: string) => [MARGIN_KEY, id] as const,
};
